import { CSSProperties, useContext } from "react";
import { PendingCapitalI } from "../../../../../../api/request/Lead/Interfaces/PolicyInterface";
import { I18nContext } from "../../../../../../context/i18n.context";
import { pendingCapitalFor, pendingCapitalText } from "./pendingCapital";

interface PendingCapitalLineProps {
  pendingCapital?: PendingCapitalI | null;
  /** Capital vigente que se está pintando encima. */
  current: number;
  /** Garantía; sin ella, el capital principal. */
  trait?: string;
  style?: CSSProperties;
}

/**
 * Línea siempre visible (no tooltip) bajo un capital vigente cuando hay una
 * bajada aprobada que aún no rige. No pinta nada si no la hay.
 */
const PendingCapitalLine = ({ pendingCapital, current, trait, style }: PendingCapitalLineProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);
  const amount = pendingCapitalFor(pendingCapital, current, trait);
  if (null === amount || !pendingCapital) return null;

  return (
    <p
      data-testid="pending-capital"
      style={{ fontSize: 13, fontWeight: 500, color: "#6b7280", margin: "4px 0 0", ...style }}
    >
      {pendingCapitalText(translate, amount, pendingCapital.effectiveDate)}
    </p>
  );
};

export default PendingCapitalLine;
